import { createAction } from 'redux-act';
import { toastr } from 'react-redux-toastr';
import { url } from 'utils/url';
import { errorMsg, refreshToken } from 'utils';
import axios from 'axios';

export const WEB_LAYOUT_FETCH = createAction('WEB_LAYOUT_FETCH');
export const WEB_LAYOUT_FETCH_DATA_SUCCESS = createAction('WEB_LAYOUT_FETCH_DATA_SUCCESS');
export const WEB_LAYOUT_FETCH_DATA_FAIL = createAction('WEB_LAYOUT_FETCH_DATA_FAIL');

export const WEB_LAYOUT_DELETE_INIT = createAction('WEB_LAYOUT_DELETE_INIT');
export const WEB_LAYOUT_DELETE_SUCCESS = createAction('WEB_LAYOUT_DELETE_SUCCESS');
export const WEB_LAYOUT_DELETE_FAIL = createAction('WEB_LAYOUT_DELETE_FAIL');

export const WEB_LAYOUT_CREATE_INIT = createAction('WEB_LAYOUT_CREATE_INIT');
export const WEB_LAYOUT_CREATE_SUCCESS = createAction('WEB_LAYOUT_CREATE_SUCCESS');
export const WEB_LAYOUT_CREATE_FAIL = createAction('WEB_LAYOUT_CREATE_FAIL');

export const WEB_LAYOUT_MODIFY_INIT = createAction('WEB_LAYOUT_MODIFY_INIT');
export const WEB_LAYOUT_MODIFY_SUCCESS = createAction('WEB_LAYOUT_MODIFY_SUCCESS');
export const WEB_LAYOUT_MODIFY_FAIL = createAction('WEB_LAYOUT_MODIFY_FAIL');

export const WEB_LAYOUT_CLEAN_UP = createAction('WEB_LAYOUT_CLEAN_UP');
export const WEB_LAYOUT_CLEAR_DATA_LOGOUT = createAction('WEB_LAYOUT_CLEAR_DATA_LOGOUT');

export const fetchWebLayout = ({ siteId }) => async (dispatch) => {
  dispatch(WEB_LAYOUT_FETCH());
  try {
    const token = await refreshToken();
    const res = await axios.get(`${url}/webLayout/list/${siteId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return dispatch(WEB_LAYOUT_FETCH_DATA_SUCCESS({ list: res.data.data || [] }));
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_LAYOUT_FETCH_DATA_FAIL({ error }));
  }
};

export const addWebLayout = (data, callback) => async (dispatch) => {
  dispatch(WEB_LAYOUT_CREATE_INIT());
  try {
    const token = await refreshToken();
    const res = await axios.post(`${url}/webLayout/create`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    toastr.success('', 'Layout created successfully');
    dispatch(WEB_LAYOUT_CREATE_SUCCESS({ layout: res.data.data }));
    if (callback) callback();
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_LAYOUT_CREATE_FAIL({ error }));
  }
};

export const updateWebLayout = (id, data, callback) => async (dispatch) => {
  dispatch(WEB_LAYOUT_MODIFY_INIT());
  try {
    const token = await refreshToken();
    const res = await axios.put(`${url}/webLayout/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    toastr.success('', 'Layout updated successfully');
    dispatch(WEB_LAYOUT_MODIFY_SUCCESS({ layout: res.data.data, id }));
    if (callback) callback();
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_LAYOUT_MODIFY_FAIL({ error }));
  }
};

export const deleteWebLayout = (id, callback) => async (dispatch) => {
  dispatch(WEB_LAYOUT_DELETE_INIT());
  try {
    const token = await refreshToken();
    await axios.delete(`${url}/webLayout/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    toastr.success('', 'Layout deleted successfully');
    dispatch(WEB_LAYOUT_DELETE_SUCCESS({ id }));
    if (callback) callback();
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_LAYOUT_DELETE_FAIL({ error }));
  }
};
